export type Host = {
  domains: string[];
  port: number;
  httpsRedirect?: boolean;
  builder: string;
  cluster: string;
};

const protocols = new Map<number, string>();
protocols.set(80, 'http://');
protocols.set(443, 'https://');

const makePreviewUrl = (url: URL, pathname = '') => {
  const base = `${url.protocol}//${process.env.NEXT_PUBLIC_VERCEL_URL}`;
  return new URL(pathname, base);
};

const selectDomain = (domains: string[]) => {
  if (domains.length === 1) return domains[0];
  for (const domain of domains) {
    const parts = domain.split('.');
    if (parts[0] === 'www') return domain;
  }

  return domains[0];
};

const hostToUrl = (host: Host) =>
  new URL(`${protocols.get(host.port)}${selectDomain(host.domains)}`);

const urlFromHosts = (hosts: Host[]) => {
  const httpHost = hosts.find((host) => host.port === 80);
  const httpsHost = hosts.find((host) => host.port === 443);

  if (httpHost?.httpsRedirect && !httpsHost)
    throw new Error('No https host for upgrade');

  if (httpHost && httpsHost) return hostToUrl(httpsHost);
  if (httpsHost) return hostToUrl(httpsHost);
  if (httpHost) return hostToUrl(httpHost);

  throw new Error('No valid host found!');
};

const deploymentUrl = (pathname = '') => {
  const url = new URL(pathname, process.env.NEXT_PUBLIC_SELF_URL);
  const isPreview = process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview';
  return isPreview ? makePreviewUrl(url, pathname) : url;
};

const parseIcsDate = (icsDate: string) => {
  const year = Number.parseInt(icsDate.substring(0, 4));
  const month = Number.parseInt(icsDate.substring(4, 6));
  const day = Number.parseInt(icsDate.substring(6, 8));

  const hour = Number.parseInt(icsDate.substring(9, 11));
  const minute = Number.parseInt(icsDate.substring(11, 13));
  const second = Number.parseInt(icsDate.substring(13, 15));

  return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
};

const amazonUrlValid = (url: URL) => {
  const expiresSeconds = Number.parseInt(
    url.searchParams.get('X-Amz-Expires') ?? '0'
  );

  const createdDate = parseIcsDate(
    url.searchParams.get('X-Amz-Date') ?? '19970714T170000Z'
  );

  const expirationTime = expiresSeconds * 1000;
  const createdTime = createdDate.getTime();
  const currentTime = Date.now();

  return expirationTime + createdTime > currentTime;
};

export { amazonUrlValid, deploymentUrl, urlFromHosts };
